<fa-icon [icon]="[type, name]" [size]="size" ></fa-icon>
